import { useTracking } from 'react-tracking';

import { useMount } from '@simplywallst/ui-core';
import { Link } from '@simplywallst/ui-core/next';

import { OneColumn } from '@/components/Layout';
import DocumentHeader from '@/components/DocumentHeader';

import { GiftCard } from './components/GiftCard';
import { RedeemForm } from './components/RedeemForm';
import { withFlag } from '../withFlag';

const Redeem = () => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
    subject: 'page',
  });

  useMount(() => {
    trackEvent({ action: 'landed' });
  });

  return (
    <Track>
      <DocumentHeader title="Redeem Gift Card" />
      <OneColumn>
        <div className="mt-[100px] px-4 md:px-0">
          <div className="grid grid-rows-[180px_repeat(3,auto)] place-items-center gap-6">
            <GiftCard />
            <h2 className="m-0 text-center text-3xl text-solid">
              Redeem your gift card
            </h2>
            <RedeemForm />
            <div className="mt-6 grid place-items-center gap-14 text-center">
              <div>
                <p className="mb-0 text-xs text-subtle">
                  Looking to purchase a gift card?
                </p>
                <Link
                  href="/gift-card/purchase"
                  className="text-xs no-underline hover:underline focus:underline"
                >
                  View gift card options
                </Link>
              </div>

              <div>
                <p className="mb-0 text-xs text-subtle">
                  Need help? Visit our{' '}
                  <Link
                    href="https://support.simplywall.st/hc/en-us/articles/11498507730191-FAQS-Gift-Subscription"
                    target="_blank"
                    className="decoration-underline text-subtle"
                  >
                    FAQ
                  </Link>
                  {' or '}
                  <Link
                    href="https://support.simplywall.st/hc/en-us/requests/new"
                    target="_blank"
                    className="decoration-underline text-subtle"
                  >
                    Contact Support?
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </OneColumn>
    </Track>
  );
};

const FlagWrapper = withFlag(Redeem);
export { FlagWrapper as Redeem };
